import * as React from "react"

const SvgArrowDownRightCurved = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m17.175 12.143-2.9-2.9a.92.92 0 0 1-.287-.7q.012-.4.312-.7.3-.276.7-.288t.7.288l4.6 4.6q.3.3.3.7t-.3.7l-4.6 4.6a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.713 0-.412.3-.712l2.875-2.875H8q-2.075 0-3.537-1.463Q3 11.217 3 9.143v-3q0-.425.288-.713A.97.97 0 0 1 4 5.143q.424 0 .713.287.287.288.287.713v3q0 1.25.875 2.125A2.9 2.9 0 0 0 8 12.143z" />
  </svg>
)
export default SvgArrowDownRightCurved
